import React from 'react'
import HeaderThree from '../header/HeaderThree';
import BannerThree from '../elements/BannerThree';
import ServiceThree from '../elements/ServiceThree';
import SkillOne from '../elements/SkillOne';
import AboutThree from '../elements/AboutThree';
import PortfolioThree from '../elements/PortfolioThree';
import ContactThree from '../elements/ContactThree';
import TestimonialsThree from '../elements/TestimonialsThree';
import LargeVideo from '../elements/LargeVideo';
import BlogThree from '../elements/BlogThree';
import CallToAction from '../elements/CallToAction';
import Footer from '../elements/Footer';

function HomeThree(){
    return(
    <div className="index-three">
        <HeaderThree/>
        <main>

            <BannerThree/>
            <ServiceThree/>
            <SkillOne/>
            <AboutThree/>
            <PortfolioThree/>
            <ContactThree/>
            <TestimonialsThree/>
            <LargeVideo/>
            <BlogThree/>




            <CallToAction/>
            <Footer/>
        </main>
    </div>
    )
}


export default HomeThree